import { render, staticRenderFns } from "./ExplainData.vue?vue&type=template&id=5073f931&scoped=true&"
import script from "./ExplainData.vue?vue&type=script&lang=js&"
export * from "./ExplainData.vue?vue&type=script&lang=js&"
import style0 from "./ExplainData.vue?vue&type=style&index=0&id=5073f931&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5073f931",
  null
  
)

export default component.exports